import {useCallback, useEffect, useRef, useState} from "react";

import Paper from '@material-ui/core/Paper';
import {Grid} from "@material-ui/core";
import {createStyles, makeStyles} from '@material-ui/core/styles';

import TextField from "@base/Inputs/Text";
import File from '@base/Inputs/File';
import Loading from "@base/Loading/Loading";

import {ButtonCancel, ButtonSave} from "@base/Button/ButtonForm";
import VisualizadorDeArquivo from '@base/VisualizadorDeArquivo';
import AuthorizedFunction from '@security/AuthorizedFunction';
import EscolaService from "@services/EscolaService";
import CartaoService from "@services/CartaoService";

import AnoEscolarService from "@services/AnoEscolarService";
import RacaService from "@services/RacaService";
import Toast from "@base/Toast";
import { cpfMask,dataMask,telefoneMask,dddMask,notaMask,nomeMask } from '@helpers/MaskHelper'

import { montarLinkCorte } from '@base/VisualizadorDeArquivo/VisualizadorDeArquivo';

export const Cartao = (props) => {

  const toastRef = useRef(null);
  const codigoCartao = props.codigo;
  const processo = props.processo;
  const id = props.id;
  const escola = props.escola;
  const nivel = codigoCartao.substring(10, 11);
  const cartao = props.cartao;
  const [corCartao, setCorCartao] = useState();
  let onUpdate = props.onUpdate;
  const tratamento = props.tratamento;
  const [nome, setNome] = useState('');
  const [dataNascimento, setDataNascimento] = useState('');
  const [ddd, setDdd] = useState('');
  const [telefone, setTelefone] = useState('');
  const [cpf, setCpf] = useState('');
  const [email, setEmail] = useState('');
  const [turno, setTurno] = useState([]);
  const [sexo, setSexo] = useState([]);
  const [raca, setRaca] = useState('');
  const [anoEscolar, setAnoEscolar] = useState([]);
  const [respostas, setRespostas] = useState([]);
  const [nota, setNota] = useState('');
  const [notaCalculada, setNotaCalculada] = useState('');
  const [ilegivel, setIlegivel] = useState(false);
  const [racas, setRacas] = useState([]);
  const [anosEscolares, setAnoEscolares] = useState([]);
  const [blob, setBlob] = useState();
  const [cartaoId, setCartaoId] = useState('');
  const [numeroObjetoPostal, setNumeroObjetoPostal] = useState('');
  const [nomeArquivo, setNomeArquivo] = useState('');

  const [, setFormTratamentoStatus] = useState("");
  const [, setFormOrigemProblema] = useState("");
  const [, setFormOrigemProblemaOutro] = useState("");
  const [, setFormTratamentoPendencia] = useState("");

  const [inep, setInep] = useState("")
  const isValido = (obj) => {

    let mensagem = "";

    if (validaValor(obj.nomeAluno)) {
      mensagem += `<li>O campo 'nome' é obrigatório.</li>`;
    } else if (isSuspeitaCampoVazio(obj.nomeAluno)) {
      mensagem += `<li>Para o campo 'nome' ser considerado vazio deve conter '@@'.</li>`;
    }

    if (validaValor(obj.cpf)) {
      mensagem += `<li>O campo 'cpf' é obrigatório.</li>`;
    } else if (isSuspeitaCampoVazio(obj.cpf)) {
      mensagem += `<li>Para o campo 'cpf' ser considerado vazio deve conter '@@'.</li>`;
    }

    if (validaValor(obj.dataNascimento)) {
      mensagem += `<li>O campo 'data de nascimento' é obrigatório.</li>`;
    } else if (isSuspeitaCampoVazio(obj.dataNascimento)) {
      mensagem += `<li>Para o campo 'data de nascimento' ser considerado vazio deve conter '@@'.</li>`;
    }

    if (validaValor(obj.nota)) {
      mensagem += `<li>O campo 'nota' é obrigatório.</li>`;
    } else if (isSuspeitaCampoVazio(obj.nota)) {
      mensagem += `<li>Para o campo 'nota' ser considerado vazio deve conter '@@'.</li>`;
    }

    if (validaValor(obj.email)) {
      mensagem += `<li>O campo 'email' é obrigatório.</li>`;
    } else if (isSuspeitaCampoVazio(obj.email)) {
      mensagem += `<li>Para o campo 'email' ser considerado vazio deve conter '@@'.</li>`;
    }

    if (validaValor(obj.telefone)) {
      mensagem += `<li>O campo 'telefone' é obrigatório.</li>`;
    } else if (isSuspeitaCampoVazio(obj.telefone)) {
      mensagem += `<li>Para o campo 'telefone' ser considerado vazio deve conter '@@'.</li>`;
    }

    if (validaValor(obj.ddd)) {
      mensagem += `<li>O campo 'DDD' é obrigatório.</li>`;
    } else if (isSuspeitaCampoVazio(obj.ddd)) {
      mensagem += `<li>Para o campo 'DDD' ser considerado vazio deve conter '@@'.</li>`;
    }

    return {
      ok: mensagem === "",
      mensagem: `${mensagem}`
    }
  }

  const getCorPorNivel = (nivel) => nivel === 1 ? "#fff1cc" : nivel === 2 ? "#ffeae6" : "#d2e9f7";

  const validaValor = (valor) => {
    return valor === null || valor === undefined || valor === "";
  }

  const isSuspeitaCampoVazio = (valor) => {
    const v = valor ? valor.trim() : '';
    return v.length === 2 && v !== '@@' && v.includes('@');
  }

  const ajustarArrobas = (valor) => {
    const v = valor ? valor.trim() : '';
    return v === '@' ? '@@' : v;
  }

  const tratarPendencia = () => {
    let obj = {
     respostas: respostas.map((resposta, index) => {
      if (resposta === undefined || resposta.length === 0) {
        return undefined;
      } else if (resposta.length > 1) {
        return 'M';
      } else {
        return resposta[0];
      }
    }),
      nota: nota,
    };
    EscolaService.atualizarStatusTratamentoNota(processo, id, obj).then(resultado => {
      props.onSaveStatus(resultado);
    });
  }

  const submit = () => {

    if (tratamento) {
      tratarPendencia()
    }else{

    let respostasTemp = respostas.map((resposta, index) => {
      if (!resposta || resposta.length === 0) {
        return undefined;
      } else if (resposta.length > 1) {
        return 'M';
      } else {
        return resposta[0];
      }
    });

    let obj = {
      nomeAluno: ajustarArrobas(nome),
      respostas: respostasTemp,
      dataNascimento: ajustarArrobas(dataNascimento),
      cpf: ajustarArrobas(cpf),
      ddd: ajustarArrobas(ddd),
      telefone: ajustarArrobas(telefone),
      nota: ajustarArrobas(nota),
      sexo: sexo,
      anoEscolar: anoEscolar,
      turno: turno,
      raca: raca,
      email: ajustarArrobas(email)
    };

    let valido = isValido(obj);

    if (valido.ok) {

      EscolaService.registrarDadosDoCartao(processo, id, obj)
        .then(resultado => {
          onUpdate(resultado);
        });

    } else {

      toastRef.current.show("warning", "Erro de validação! " + valido.mensagem);
    }

  }
  }

  const getArrayQtdQuestoes = () => {

    let array = [];
    for (let c = 0; c < 20; c++) array.push(c);
    return array;

  }

  const getOpcoesQuestoes = () => ['A', 'B', 'C', 'D', 'E'];
  const getOpcoesSexo = () => [{value: "FEMININO", label: "Fem"}, {value: "MASCULINO", label: "Masc"}];
  const getOpcoesTurno = () => [{value: "MANHA", label: "Manhã"}, {value: "TARDE", label: "Tarde"}, {
    value: "NOITE",
    label: "Noite"
  }];
  const atualizarResposta = (e, index) => {

    let nstate = respostas[index] ? [...respostas[index]] : [];
    e.target.checked ? nstate.push(e.target.value) : removeArrayItem(nstate, e.target.value);
    respostas[index] = nstate;
    setRespostas([...respostas]);

    let respostasTemp = respostas.map((resposta, index) => {
      if (!resposta || resposta.length === 0) {
        return {questao: index + 1, resposta: undefined};
      } else if (resposta.length > 1) {
        return {questao: index + 1, resposta: 'M'};
      } else {
        return {questao: index + 1, resposta: resposta[0]};
      }
    });

    const obj = {
      nivel: nivel,
      respostas: respostasTemp,
      inep: inep
    }

    CartaoService.calcularNota(processo, obj ).then(resultado => {
      setNotaCalculada(resultado.data);
    });


  }

  const removeArrayItem = (arr, value) => {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  const carregaCartao = useCallback((cartao) => {

    setCartaoId(cartao.id);
    setNome(cartao.nomeAluno);
    setEmail(cartao.email);

    setNumeroObjetoPostal(cartao.numeroObjetoPostal);
    setNomeArquivo(cartao.nomeArquivo);

    let respostasTemp = [];

    if (cartao.respostas) {
      respostasTemp = cartao.respostas.map((resposta, index) => {
        if (resposta === 'M') {
          return ['A', 'B', 'C', 'D', 'E'];
        } else {
          return resposta;
        }
      });
    }

    setRespostas(respostasTemp);
    setNota(cartao.nota);
    setNotaCalculada(cartao.notaCalculada);
    setDataNascimento(cartao.dataNascimento);
    setDdd(cartao.ddd);
    setTelefone(cartao.telefone);
    setCpf(cartao.cpf);
    setSexo(cartao.sexo && cartao.sexo.length > 0 ? cartao.sexo.map(s => s.id) : undefined);
    setAnoEscolar(cartao.anoEscolar ? cartao.anoEscolar.map(s => s.id) : undefined);
    setRaca(cartao.raca ? cartao.raca.map(r => r.id) : undefined);
    setTurno(cartao.turno ? cartao.turno.map(r => r.id) : undefined);
    setIlegivel(cartao.arquivoLegivel !== undefined && cartao.arquivoLegivel === false)
    setBlob(cartao.blob);
    setCorCartao(getCorPorNivel(cartao.nivel));
    if (cartao.tratamentoNota) {
      setFormTratamentoStatus(cartao.tratamentoNota.nota);
      setFormTratamentoPendencia(cartao.tratamentoNota.tipo);
      setFormOrigemProblema(cartao.tratamentoNota.origem);
      setFormOrigemProblemaOutro(cartao.tratamentoNota.descricaoOrigemOutro);
    }
  },[]);

    const carregarDadosDoCartao = useCallback(() => {
    limparCartao();

    Promise.all([
      AnoEscolarService.listar(nivel),
      RacaService.listar(),
      EscolaService.buscaDadosDoCartao(processo, id)
    ]).then(resposta => {
      setAnoEscolares(resposta[0].data);
      setRacas(resposta[1].data);
      setInep(resposta[2].data.codigoInep)
      if (cartao) {

        carregaCartao(cartao);

      } else {

        EscolaService.downloadArquivoCartao(processo, escola, id).then(respostaArquivo => {
          resposta[2].data.blob = respostaArquivo.data;
          carregaCartao(resposta[2].data);
        }).catch(resultado => {
          carregaCartao(resposta[2].data);
        });

      }

    });

  }, [escola, nivel, processo, id, cartao, carregaCartao]);

  const limparCartao = () => {

    setCartaoId();
    setNome("");
    setEmail("");

    setRespostas([]);
    setNota("");
    setNotaCalculada("");
    setDataNascimento("");
    setDdd("");
    setTelefone("");
    setCpf("");
    setSexo([]);
    setAnoEscolar([]);
    setRaca("");
    setTurno([]);
    setIlegivel(false);
    setBlob();
    setCorCartao();
    
    setFormTratamentoStatus();
    setFormTratamentoPendencia();
    setFormOrigemProblema();
    setFormOrigemProblemaOutro();

  };

  const uplaod = (arquivo) => {

    const config = {headers: {'content-type': 'multipart/form-data'}};
    const file = new FormData();

    file.append('nmArquivo', arquivo.name)
    file.append('tipoArquivo', arquivo.type)
    file.append('descricao', arquivo.description);
    file.append('arquivo', arquivo)
    file.append('processo', processo);
    file.append('escola', cartao.escola);

    EscolaService.uploadArquivoCartao(processo, cartao.escola, cartao.id, file, config)
      .then(resultado => {
        toastRef.current.show("success", "Cartão recebido com sucesso!");
        setBlob(arquivo);
      }).catch(resultado => {
      toastRef.current.show("error", "Não foi posível fazer upload do arquivo.");
    });

  }

  useEffect(() => carregarDadosDoCartao(), [carregarDadosDoCartao]);

  const useStyles = makeStyles(theme =>
    createStyles({
      smallRadioButton: {
        "& svg": {
          width: "0.5em",
          height: "0.5em"
        }
      }
    })
  );

  return (
    <>
      <Toast ref={toastRef}/>
      <Paper
        style={{backgroundColor: corCartao, padding: "0px 15px 15px 15px"}}
        className={useStyles().wrapper}
        elevation={0}
      >

        <Grid alignItems="center" container>
          <Grid item sm={6}>
            <Grid alignItems="center" container>
              <Grid item sm={12}>
                <TextField
                  label='Nome'
                  required
                  autoFocus
                  value={nome}
                  disabled={tratamento}
                  name="nome"
                  autoComplete="off"
                  onChange={(e) => setNome(nomeMask(e.target.value))}
                />
              </Grid>
            </Grid>
            {tratamento ? <></> :
              <>
                <Grid alignItems="center" spacing={3} container>
                  <Grid item sm={4}>
                    <TextField
                      label='Data Nascimento'
                      required
                      value={dataNascimento}
                      disabled={tratamento}
                      name="dataNascimento"
                      autoComplete="off"
                      onChange={(e) => setDataNascimento(dataMask(e.target.value))}
                    />
                  </Grid>
                  <Grid item sm={4}>
                    <TextField
                      label='DDD'
                      required
                      value={ddd}
                      disabled={tratamento}
                      name="ddd"
                      autoComplete="off"
                      onChange={(e) => setDdd(dddMask(e.target.value))}
                    />
                  </Grid>
                  <Grid item sm={4}>
                    <TextField
                      label='Telefone'
                      required
                      value={telefone}
                      disabled={tratamento}
                      name="telefone"
                      autoComplete="off"
                      onChange={(e) => setTelefone(telefoneMask(e.target.value))}
                    />
                  </Grid>
                  <Grid item sm={4}>
                    <TextField
                      label='CPF'
                      required
                      value={cpf}
                      disabled={tratamento}
                      name="cpf"
                      autoComplete="off"
                      onChange={(e) => setCpf(cpfMask(e.target.value))}
                    />
                  </Grid>
                </Grid>

                <Grid alignItems="center" container>
                  <Grid item sm={12}>
                    <TextField
                      label='E-mail'
                      required
                      value={email}
                      disabled={tratamento}
                      name="email"
                      autoComplete="off"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Grid>
                </Grid>


                <Grid alignItems="center" container>
                  <Grid item sm={3}>
                    <div style={{color: "#666", fontSize: "12px"}}>Ano</div>
                    {anosEscolares.map((anoEscolarOp, key) => {
                        return (
                          <div>
                            <input
                              type="checkbox"
                              name="anoEscolar"
                              value={anoEscolarOp.id}
                              checked={anoEscolar && anoEscolar.includes(anoEscolarOp.id)} onChange={(e) => {
                              let anoEscolarState = anoEscolar ? [...anoEscolar] : [];
                              e.target.checked ? anoEscolarState.push(e.target.value) : removeArrayItem(anoEscolarState, e.target.value);
                              setAnoEscolar(anoEscolarState);
                            }}/>
                            {anoEscolarOp.descricao}
                          </div>
                        );
                      }
                    )}
                  </Grid>
                  <Grid item sm={3}>
                    <div style={{color: "#666", fontSize: "12px"}}>Turno</div>
                    {getOpcoesTurno().map((turnoOp, key) => {
                        return (
                          <div>
                            <input
                              type="checkbox"
                              name="turno"
                              value={turnoOp.value}
                              checked={turno && turno.includes(turnoOp.value)} onChange={(e) => {
                              let nstate = turno ? [...turno] : [];
                              e.target.checked ? nstate.push(e.target.value) : removeArrayItem(nstate, e.target.value);
                              setTurno(nstate);
                            }}

                            />
                            {turnoOp.label}
                          </div>
                        );
                      }
                    )}
                  </Grid>
                  <Grid item sm={3}>
                    <div style={{color: "#666", fontSize: "12px"}}>Sexo</div>
                    {getOpcoesSexo().map((sexoOp, key) => {
                        return (
                          <div>
                            <input
                              type="checkbox"
                              name="sexo"
                              value={sexoOp.value}
                              checked={sexo && sexo.includes(sexoOp.value)} onChange={(e) => {
                              let nstate = sexo ? [...sexo] : [];
                              e.target.checked ? nstate.push(e.target.value) : removeArrayItem(nstate, e.target.value);
                              setSexo(nstate);
                            }}
                            />
                            {sexoOp.label}
                          </div>
                        );
                      }
                    )}
                  </Grid>
                  <Grid item sm={3}>
                    <div style={{color: "#666", fontSize: "12px"}}>Opção de Cor/Raça</div>
                    {racas.map((racaOp, key) => {
                        return (
                          <div>
                            <input
                              type="checkbox"
                              name="raca"
                              value={racaOp.id}
                              checked={raca && raca.includes(racaOp.id)}
                              onChange={(e) => {
                                let nstate = raca ? [...raca] : [];
                                e.target.checked ? nstate.push(e.target.value) : removeArrayItem(nstate, e.target.value);
                                setRaca(nstate);
                              }}

                            />
                            {racaOp.descricao}
                          </div>
                        );
                      }
                    )}
                  </Grid>
                </Grid>
              </>
            }
            <Grid alignItems="center" container>
              <Grid item sm={12}><br/>
                <div style={{color: "#666", fontSize: "12px"}}>Respostas</div>
                <table style={{width: "100%"}} cellspacing="0" cellpadding="0">
                  <tr>
                    {getArrayQtdQuestoes().map((pergunta, index) => {
                      return (
                        <td style={index % 2 === 0 ? {backgroundColor: "#eee"} : {backgroundColor: "#fff"}}>
                          <div style={{textAlign: "center", fontWeight: "bold"}}>{index + 1}</div>

                          {getOpcoesQuestoes().map((resposta, key) => {
                              return (
                                <div>
                                  <input
                                    type="checkbox"
                                    name={`respostas[${index}]`}
                                    value={resposta}
                                    checked={respostas && respostas[index] ? respostas[index].includes(resposta) : ""}
                                    onChange={(e) => atualizarResposta(e, index)}
                                  />
                                  {resposta}
                                </div>
                              );
                            }
                          )}

                        </td>
                      );
                    })}
                  </tr>
                </table>
              </Grid>
            </Grid>

            <Grid alignItems="center" container>
              <Grid item sm={3}>
                <TextField
                  length={2}
                  label='Nota'
                  required
                  value={nota}
                  name="nota"
                  autoComplete="off"
                  onChange={(e) => setNota(notaMask(e.target.value))}
                />
              </Grid>
              {cartaoId &&
                <>
                  <Grid sm={1}/>
                  <Grid item sm={3}>
                    <TextField
                      readonly
                      disabled={true}
                      label='Nota Calculada'
                      value={notaCalculada ?? "--"}
                      name="notaCalculada"
                    />
                  </Grid>
                </>
              }
            </Grid>
            <ButtonSave onClick={submit}/>
            {props.onCancel ? <ButtonCancel onBack={props.onCancel}/> : <></>}
          </Grid>
          <Grid container sm={6}>
            {!blob ?
              <Loading />
            :
              <>
                <Grid item sm={12}>
                  <VisualizadorDeArquivo
                    linkCorte={montarLinkCorte(codigoCartao, numeroObjetoPostal, nomeArquivo)}
                    ilegivel={ilegivel}
                    aoMarcarComoIlegivel={() => {
                      EscolaService.cartaoIlegivel(processo, escola, id).then(resultado => {
                        setIlegivel(true);
                      });
                    }}
                    blob={blob}
                  />
                </Grid>

                {!tratamento && (AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"])) &&
                  <Grid item sm={12}>
                    <File handleUpload={uplaod}/>
                  </Grid>
                }
              </>
            }
          </Grid>
        </Grid>

      </Paper>
    </>
  );
}

export default Cartao;
